export default __webpack_public_path__ + "static/media/feature_4.d5cbcb89.png";